const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    listarPorTipoIdade: async (maiorIdade) => {
        try {
          const req = await fetch(`${BASE_API}site/divisoes/idade/${maiorIdade}`, {
            method: 'GET',
            headers: headers
          });
          const json = await req.json();
                json.data = json.data ?? json;
                json.statusRetorno = req.status;

          return json;
        } catch (error) {
          return(error);
        }
      },
};